// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"122":"085e74dc242d08e444f0","944":"89019461af885877f119"}[chunkId] + ".js";
};